<template>
  <div class="footer-container">
    <div class="footer-content">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h3 class="footer-title">Negru Marian Liviu </h3> &nbsp;
            <h5 class="footer-title"><i>- avocat Baroul Salaj</i></h5>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-lg-6 footer-column">
            <h4>Contact</h4>
            <p>
              <i class="fa fa-map-marker footer-icon"></i> {{ address }}
            </p>
            <p><i class="fa fa-phone footer-icon"></i> {{ phone }}</p>
            <p><i class="fa fa-envelope footer-icon"></i> {{ email }}</p>
          </div>
          <div class="col-lg-6 footer-column">
            <h4> Link-uri utile</h4>
          </div>
        </div> -->
      </div>
    </div>
    <div class="copy-right">
      <p>© Copyright {{ new Date().getFullYear() }} | All rights reserved.</p> 
    </div>
  </div>
</template>
<script>
import { ADDRESS, PHONE, EMAIL } from '../constants';
export default {
  name: 'Footer',
  data: function () {
    return {
      address: ADDRESS,
      phone: PHONE,
      email: EMAIL
    }
  },
}
</script>

<style scoped lang="scss">
@import "../scss/_variables.scss";
.footer-content {
  background-color: #262626;
  color: $theme-color;
  padding: 20px 0;
  text-align: center;
  .footer-icon {
    color: $theme-color;
    margin-right: 10px;
  }
}
p {
  color: $white;
  margin-bottom: 5px;
}
.copy-right{
  padding: 30px;
  background: #000;
  text-align: center;
  color: $white
}
h5 {
  margin-bottom: 15px;
}
h2{
  margin-bottom: 20px;
}
.footer-title {
  margin-bottom: 5px;
  display: inline-block;
}
.footer-column {
  margin: 30px 0 30px;
  font-size: 18px;

  h4 {
    margin-bottom: 20px;
  }
}
// @media only screen and (min-width: 992px) { 
//   .footer-content {
//     padding: 50px 50px 100px;
//   }
// }
</style>